import { carouselItems } from '@/mocks/homeMocks';

export default function CarouselSection() {
  return (
    <section id="carousel" className="py-10 md:py-14 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-7xl mx-auto">
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 mb-6 scroll-mt-20">
            焦点专题
          </h2>
          <div className="flex flex-col gap-6">
            {carouselItems.map((item) => (
              <a
                key={item.id}
                href="#carousel"
                className="group relative w-full rounded-lg overflow-hidden border border-background-200/70 cursor-pointer hover:border-primary-300 transition-all"
              >
                <div className="relative w-full aspect-[21/9] md:aspect-[21/7] overflow-hidden bg-background-200">
                  <img
                    src={item.image}
                    alt={item.title}
                    className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                    loading="lazy"
                  />
                  <div className="absolute inset-0 bg-gradient-to-r from-foreground-950/60 via-foreground-950/30 to-transparent"></div>
                </div>
                <div className="absolute inset-0 flex items-center p-6 md:p-10">
                  <div className="max-w-lg">
                    <span className="inline-block px-3 py-1 bg-primary-500 text-white text-xs rounded-full mb-3 whitespace-nowrap">
                      {item.tag}
                    </span>
                    <h3 className="text-xl md:text-3xl text-white mb-2 group-hover:text-primary-200 transition-colors">
                      {item.title}
                    </h3>
                    <p className="text-sm md:text-base text-foreground-200 mb-1 hidden sm:block">
                      {item.subtitle}
                    </p>
                    <p className="text-xs md:text-sm text-foreground-300 leading-relaxed hidden md:block">
                      {item.description}
                    </p>
                  </div>
                </div>
              </a>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}